module.exports = __webpack_public_path__ + "media/images/features/3/main-31783abc751f17c1c71bbb8d792c2e24.jpg";